/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_InfoInputs */



/**
* | output |
* | --- |
* | "V-Chip Information" |
*
* @param {Subtitle_Export_Vchip_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_info = /** @type {((inputs?: Subtitle_Export_Vchip_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Informations sur la puce V")
	if (locale === "de") return /** @type {LocalizedString} */ ("V-Chip-Informationen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Informazioni sul V-Chip")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Информация о V-чипе")
	if (locale === "es") return /** @type {LocalizedString} */ ("Información del V-Chip")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("V-Chip 信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Vチップ情報")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वी-चिप जानकारी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Informações sobre o V-Chip")
	return /** @type {LocalizedString} */ ("V-Chip Information")
});